var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c(_vm.contactShareableIcon,{tag:"component",staticClass:"h-4 inline-block",class:_vm.shareStyle,style:(_vm.verticalOffsetStyle)}),_vm._v(" "+_vm._s(_vm.shareStatusString)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }